<template>
  <div class="ui-block">
    <article class="hentry post">
      <div class="fc fc-ltr fc-unthemed">
        <div class="fc-toolbar">
          <div class="fc-left">
            <div
              v-if="currentWeekNr > 1"
              class="fc-button-group"
            >
              <button
                type="button"
                class="fc-prev-button fc-button fc-state-default fc-corner-left"
                @click="subtractWeek"
              >
                <span class="fc-icon fc-icon-left-single-arrow" />
              </button>
            </div>
          </div>
          <div class="fc-right">
            <div
              v-if="currentWeekNr < weeks.length"
              class="fc-button-group"
            >
              <button
                type="button"
                class="fc-next-button fc-button fc-state-default fc-corner-right"
                @click="addWeek"
              >
                <span class="fc-icon fc-icon-right-single-arrow" />
              </button>
            </div>
          </div>

          <div class="fc-clear" />
        </div>
      </div>
      <week-review-form />

      <div class="today-events calendar">
        <div class="today-events-thumb">
          <div class="date">
            <div class="day-number">
              Week
            </div>
            <div class="day-week">
              {{ startWeek }} - {{ endWeek }}
            </div>
            <div class="month-year">
              {{ isSameMonth ? startWeekMonth : startWeekMonth + ' ' + endWeekMonth }}, {{ currentYear }}
            </div>
          </div>
        </div>
        <div class="list">
          <div class="control-block-button">
            <a
              href="#"
              class="btn btn-control bg-breez"
              @click="$modal.show('week-review-form', {item: {cat_id: '', title:'', description: ''}})"
            >
              <app-icon
                name="olymp-plus-icon"
                color="white"
                size="normal"
              />
            </a>
          </div>

          <div
            id="accordion-1"
            role="tablist"
            aria-multiselectable="true"
            data-month="2"
            data-day="4"
            class="day-event"
          >
            <div class="card">
              <div
                id="headingThirtyTwo-1"
                role="tab"
                class="card-header"
              >
                <div class="event-time">
                  <time datetime="2018-02-29T09:00">Overall</time>
                </div>
                <v-collapse-group>
                  <div
                    v-for="item1 in items"
                    :key="item1.id"
                  >
                    <v-collapse-wrapper>
                      <h5
                        v-collapse-toggle
                        class="mb-2 title"
                      >
                        <span
                          data-toggle="modal"
                          data-target="#public-event"
                          class="event-status-icon"
                        >
                          <svg
                            viewBox="0 0 24 24"
                            width="24"
                            height="24"
                            role="presentation"
                            class="sprite-icon olymp-calendar-icon"
                          >
                            <use
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                              :xlink:href="`/static/sprites/icons-alpha.svg#olymp-alpha-${item1.LifeCat.icon_class}-icon`"
                            />
                          </svg>
                        </span>
                        {{ item1.title }}<i
                          aria-hidden="true"
                          class="fa fa-angle-down"
                        />
                      </h5>
                      <div v-collapse-content>
                        <div class="card-body">
                          {{ item1.description }}
                          <a
                            href="#"
                            @click="$modal.show('week-review-form', { item: item1 })"
                          >
                            <app-icon
                              name="olymp-three-dots-icon"
                              color="gray"
                              size="normal"
                            />
                          </a>
                        </div>
                      </div>
                    </v-collapse-wrapper>
                  </div>
                </v-collapse-group>
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Vue from 'vue'
import VueCollapse from 'vue2-collapse'
Vue.use(VueCollapse)

import { format } from 'date-fns'
// import moment from 'moment'
import WeekReviewForm from './WeekReviewForm'
import AppIcon from "../../common-apps/common/AppIcon"
import weekReviewStore from '../../../store/modules/personal/week-review.js'

export default {
  name: 'WeekReview',
  components: { WeekReviewForm, AppIcon },
  props: {
    date: {
      type: Date,
      default: function () { return {} }
    }
  },
  data () {
    return {
      currentYear: format(new Date(), 'yyyy')
    }
  },
  computed: mapState({
    items: state => state.weekReview ? state.weekReview.items : [],
    weeks: state => state.weekReview ? state.weekReview.weeks : [],
    startWeek: state => state.weekReview ? state.weekReview.startWeek : '',
    endWeek: state => state.weekReview ? state.weekReview.endWeek : '',
    startWeekMonth: state => state.weekReview ? state.weekReview.startWeekMonth : '',
    endWeekMonth: state => state.weekReview ? state.weekReview.endWeekMonth : '',
    isSameMonth: state => state.weekReview ? state.weekReview.isSameMonth : false,
    currentWeekNr:  state => state.weekReview ? state.weekReview.currentWeekNr : 0,
    currentWeek: state => state.weekReview ? state.weekReview.currentWeek : {}
  }),
  created () {
    if (!this.$store.hasModule('weekReview')) {
      this.$store.registerModule('weekReview', weekReviewStore)
    }
    this.$store.dispatch('weekReview/getWeeks', { date: this.date })
    this.$store.dispatch('weekReview/getCurrentWeek', { weeks: this.weeks, currentWeekNr: this.currentWeekNr, op: 'add' })
  },
  beforeDestroy () {
    this.$store.unregisterModule('weekReview')
  },
  methods: {
    addWeek () {
      this.$store.dispatch('weekReview/getCurrentWeek', { weeks: this.weeks, currentWeekNr: this.currentWeekNr, op: 'add' })
    },
    subtractWeek () {
      this.$store.dispatch('weekReview/getCurrentWeek', { weeks: this.weeks, currentWeekNr: this.currentWeekNr, op: 'subtract' })
    },
    getSvgUrl (icoClass) {
      return `/static/sprites/icons-alpha.svg#olymp-alpha-${icoClass}-icon`
    }
  }
}
</script>
